import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const config: Configuration = {
  auth: {
    clientId: '27dfac01-59a0-48d0-8b9f-1783c4f4bfaa',
    authority: 'https://login.microsoftonline.com/5b268d57-2a6f-4e04-b0de-6938583d5ebc',
    redirectUri: 'https://adc-launchpad.abbott.com/auth-response',
  },
  cache: {
    cacheLocation: 'localStorage', // configures where your cache will be stored
    storeAuthStateInCookie: true, // true if you are having issues on IE11 or Edge
  },
};

const pca = new PublicClientApplication(config);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return <MsalProvider instance={pca}>{children}</MsalProvider>;
}
